import { gql } from 'graphql-request'

export const CREATE_COIN_REQUEST = gql`
  mutation CreateCoinRequest($createCoinRequestInput: CreateCoinRequestInput!) {
    createCoinRequest(createCoinRequestInput: $createCoinRequestInput) {
      id
    }
  }
`
